import { AlertTriangle, ArrowRight } from "lucide-react";
import DeskCloseX from "@/components/common/DeskCloseX";
import useEscapeClose from "@/hooks/useEscapeClose";

const ERR = "#e0564b";

/** Fait défiler jusqu'au premier champ manquant (SaleField id=field-<key>) et le met en évidence. */
export function scrollToField(key) {
  const el = document.getElementById(`field-${key}`) || document.querySelector(`[data-field="${key}"]`);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  const focusable = el.querySelector("input, select, textarea, button");
  setTimeout(() => focusable?.focus?.(), 350);
  return true;
}

/**
 * Modale Le Desk « Champs obligatoires manquants » : liste chaque champ (section · libellé).
 * `onSaveAnyway` (optionnel) : enregistrer un dossier incomplet quand seuls des champs régularisables manquent.
 */
export default function MissingFieldsDialog({ items, onClose, onGoFirst, onSaveAnyway }) {
  useEscapeClose(onClose, !!items);
  if (!items?.length) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: 1500, background: "rgba(0,0,0,.6)", fontFamily: "Tahoma, sans-serif" }} onClick={onClose} role="dialog" aria-modal="true" data-testid="missing-fields-dialog" data-count={items.length}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: 520, maxWidth: "94vw", maxHeight: "86vh", display: "flex", flexDirection: "column", background: "#141418", border: "1px solid #26272e", borderRadius: 16, overflow: "hidden" }}>
        <div className="flex items-center" style={{ gap: 10, padding: "14px 18px 12px", borderBottom: "1px solid #26272e" }}>
          <AlertTriangle size={18} style={{ color: ERR, flexShrink: 0 }} />
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#f3f2ed" }}>Champs obligatoires manquants</div>
            <div style={{ fontSize: 11.5, color: "#a9a79e", marginTop: 2 }}>{items.length} champ{items.length > 1 ? "s" : ""} à renseigner avant de confirmer.</div>
          </div>
          <DeskCloseX onClick={onClose} testId="missing-fields-close" />
        </div>
        <div className="overflow-y-auto" style={{ padding: "8px 18px" }}>
          {items.map((it) => (
            <button key={it.key} type="button" onClick={() => { onClose(); scrollToField(it.key); }} className="flex items-center w-full text-left hover:bg-white/[.03]" style={{ gap: 10, padding: "8px 6px", borderBottom: "1px solid #1e1e24" }} data-testid={`missing-field-${it.key}`}>
              <AlertTriangle size={13} style={{ color: ERR, flexShrink: 0 }} />
              <span style={{ fontSize: 10.5, letterSpacing: ".06em", textTransform: "uppercase", color: "#8a8a92", minWidth: 110 }}>{it.section}</span>
              <span style={{ fontSize: 12.5, color: "#e8e8ec", fontWeight: 600 }}>{it.label}</span>
            </button>
          ))}
        </div>
        <div className="flex items-center justify-end" style={{ gap: 8, padding: "12px 18px 14px", borderTop: "1px solid #26272e" }}>
          {onSaveAnyway && <button type="button" onClick={onSaveAnyway} style={{ fontSize: 12, padding: "8px 14px", borderRadius: 9, color: "#c9c9d1", border: "1px solid #2e2e34" }} data-testid="missing-fields-save-anyway">Enregistrer incomplet (régulariser ensuite)</button>}
          <button type="button" onClick={onGoFirst} className="inline-flex items-center" style={{ gap: 6, fontSize: 12, fontWeight: 700, padding: "8px 16px", borderRadius: 9, background: "#2A9A7A", color: "#04140d" }} data-testid="missing-fields-go-first">Aller au premier champ<ArrowRight size={14} /></button>
        </div>
      </div>
    </div>
  );
}
